import { apiErrorDetail } from "@/apis/apiError";

const AI_GATE_REASONS: Record<string, string> = {
    AI_FEATURES_DISABLED: "AI features are not enabled for your company.",
    AI_STATUS_UNKNOWN:
        "Could not check whether AI features are enabled. Try again.",
};

export const aiGateRefusalReason = (error: unknown): string | null => {
    const detail = apiErrorDetail(error);
    if (detail === null) return null;
    return AI_GATE_REASONS[detail] ?? null;
};
